import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { NoExactResultsContainer } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/MaybeSearchPageNoProductResults/__internal__/NoExactResultsContainer";
import { useSearchPageShowNoProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShowNoProductResults";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { trackRetailersFilterClearClick } from "@faire/web-api--source/events/retailers/click/filterClear";
import React, { useCallback } from "react";

interface IProps {
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}

export const MaybeSearchPageNoProductResults: React.FC<IProps> = ({
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("MaybeSearchPageNoProductResults");

  const showNoSearchResultsContainer = useSearchPageShowNoProductResults();

  if (!showNoSearchResultsContainer) {
    return null;
  }
  return (
    <SearchPageNoProductResults
      searchPageLoadTimingRef={searchPageLoadTimingRef}
    />
  );
};

const SearchPageNoProductResults: React.FC<IProps> = ({
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("SearchPageNoProductResults");

  const {
    data: { activeFilterCount },
    clearAllFilters,
  } = useFilterStore(["activeFilterCount"]);

  const handleClearFilters = useCallback(() => {
    trackRetailersFilterClearClick("Search", "no_results_clear_all", "");
    clearAllFilters();
  }, [clearAllFilters]);

  return (
    <>
      <NoExactResultsContainer
        hasFiltersApplied={activeFilterCount > 0}
        onClearFilters={handleClearFilters}
        searchPageLoadTimingRef={searchPageLoadTimingRef}
      />
    </>
  );
};
